import type { WeComScheduleBoardResponse } from './api'
import { exchangeScheduleBoardIdentity, fetchScheduleBoard, fetchScheduleBoardIdentityStart } from './api'
import { readWeComScheduleBoardEntry } from './wecomContext'

function boardRedirectUri() {
  const url = new URL(window.location.href)
  url.hash = ''
  url.search = ''
  return url.href
}

async function exchangeCallbackIdentity() {
  const url = new URL(window.location.href)
  const code = url.searchParams.get('code')
  const state = url.searchParams.get('state')
  if (!code && !state && !url.searchParams.has('errmsg')) {
    return null
  }
  try {
    if (!code || !state) {
      throw new Error('企微身份回调参数不完整，请重试')
    }
    const identity = await exchangeScheduleBoardIdentity(code, state, boardRedirectUri())
    return identity.userid
  }
  finally {
    url.searchParams.delete('code')
    url.searchParams.delete('state')
    url.searchParams.delete('errmsg')
    window.history.replaceState({}, typeof document === 'undefined' ? '' : document.title, `${url.pathname}${url.search}${url.hash}`)
  }
}

async function startScheduleBoardIdentity() {
  const { url: authorizationUrl } = await fetchScheduleBoardIdentityStart(boardRedirectUri())
  window.location.replace(authorizationUrl)
  return await new Promise<never>(() => {})
}

export async function loadScheduleBoardFromGroupBoard(
  onEntryAccepted: () => void,
  onIdentityReady?: () => void,
) {
  // Clean the OAuth callback before configuring the JS-SDK for the current URL.
  const callbackUserId = await exchangeCallbackIdentity()
  const entry = await readWeComScheduleBoardEntry()
  if (entry !== 'internal_group_chat_board') {
    return null
  }

  onEntryAccepted()
  const currentUserId = callbackUserId ?? await startScheduleBoardIdentity()
  onIdentityReady?.()
  const board = await fetchScheduleBoard()
  return { board, currentUserId } satisfies { board: WeComScheduleBoardResponse, currentUserId: string }
}
